import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/wLbGVT341k5QnSDGNmqXJN/Tokoteta_Logo.png';
type LogoProps = {
  variant?: 'light' | 'dark';
  className?: string;
};
export function Logo({
  variant = 'light',
  className = ''
}: LogoProps) {
  return <a href="#" className={`inline-flex items-center gap-2.5 ${className}`} aria-label="TokoTeta home" data-id="element-122" data-mp="3q7i4dvtkob8o">
      <img src={LOGO_URL} alt="" className="h-9 w-9 rounded-[10px] shadow-sm" width={36} height={36} data-id="element-123" data-mp="mt4856tlh28y" />
      <span className="text-[22px] font-extrabold tracking-tight" data-id="element-124" data-mp="rrfhzhjw3cr6">
        <span className={variant === 'light' ? 'text-slate-900' : 'text-white'} data-id="element-125" data-mp="dsxvto9mu8bd">
          Toko
        </span>
        <span className={variant === 'light' ? 'text-blue-600' : 'text-slate-400'} data-id="element-126" data-mp="hsq5k4arikib">
          Teta
        </span>
      </span>
    </a>;
}